export const parseImage = (image) => {
  if (!image) return null;

  // Handle string URLs directly (backend may provide just a URL string or base64)
  if (typeof image === "string") {
    // Check if it's already a data URL or http URL
    if (image.startsWith("data:") || image.startsWith("http")) {
      return {
        url: image,
        alt: "Product Image",
      };
    }
    // Assume it's raw base64 and add data URL prefix
    return {
      url: `data:image/png;base64,${image}`,
      alt: "Product Image",
    };
  }

  // Handle Immutable.js objects
  if (image.get) {
    let url =
      image.get("filedata") ||
      image.get("FileData") ||
      image.get("url") ||
      image.get("Url") ||
      image.get("URL");

    // Format base64 if needed
    if (url && !url.startsWith("data:") && !url.startsWith("http")) {
      url = `data:image/png;base64,${url}`;
    }

    return {
      url: url,
      alt: image.get("alt") || image.get("Alt") || "Product Image",
    };
  }

  // Handle backend DTO format - check for filedata field first
  let url =
    image.imageFile ||
    image.ImageFile ||
    image.filedata ||
    image.FileData ||
    image.fileData ||
    image.url ||
    image.Url ||
    image.URL ||
    image.imageUrl ||
    image.ImageUrl ||
    image.src ||
    image.Src ||
    null;

  // Format base64 if needed
  if (url && !url.startsWith("data:") && !url.startsWith("http")) {
    url = `data:image/png;base64,${url}`;
  }

  const alt =
    image.altText ||
    image.AltText ||
    image.alt ||
    image.Alt ||
    image.alternativeText ||
    image.AlternativeText ||
    image.imageName ||
    image.ImageName ||
    "Product Image";

  // If we still don't have a URL, check if the image object itself might be the URL
  if (!url && Object.keys(image).length === 0) {
    return null;
  }

  return {
    url: url,
    alt: alt,
  };
};
